/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimeStepSettings } from "./TimeStepSettings";
import {
  TimeStepSettingsFromJSON,
  TimeStepSettingsFromJSONTyped,
  TimeStepSettingsToJSON,
  TimeStepSettingsToJSONTyped,
} from "./TimeStepSettings";
import type { WaterQualityOutputSettings } from "./WaterQualityOutputSettings";
import {
  WaterQualityOutputSettingsFromJSON,
  WaterQualityOutputSettingsFromJSONTyped,
  WaterQualityOutputSettingsToJSON,
  WaterQualityOutputSettingsToJSONTyped,
} from "./WaterQualityOutputSettings";
import type { NumericalSettings } from "./NumericalSettings";
import {
  NumericalSettingsFromJSON,
  NumericalSettingsFromJSONTyped,
  NumericalSettingsToJSON,
  NumericalSettingsToJSONTyped,
} from "./NumericalSettings";
import type { OutputSettings } from "./OutputSettings";
import {
  OutputSettingsFromJSON,
  OutputSettingsFromJSONTyped,
  OutputSettingsToJSON,
  OutputSettingsToJSONTyped,
} from "./OutputSettings";
import type { CustomizedResultArea } from "./CustomizedResultArea";
import {
  CustomizedResultAreaFromJSON,
  CustomizedResultAreaFromJSONTyped,
  CustomizedResultAreaToJSON,
  CustomizedResultAreaToJSONTyped,
} from "./CustomizedResultArea";
import type { WaterQualitySettings } from "./WaterQualitySettings";
import {
  WaterQualitySettingsFromJSON,
  WaterQualitySettingsFromJSONTyped,
  WaterQualitySettingsToJSON,
  WaterQualitySettingsToJSONTyped,
} from "./WaterQualitySettings";
import type { AggregationSettings } from "./AggregationSettings";
import {
  AggregationSettingsFromJSON,
  AggregationSettingsFromJSONTyped,
  AggregationSettingsToJSON,
  AggregationSettingsToJSONTyped,
} from "./AggregationSettings";
import type { WaterQualityCustomizedResultArea } from "./WaterQualityCustomizedResultArea";
import {
  WaterQualityCustomizedResultAreaFromJSON,
  WaterQualityCustomizedResultAreaFromJSONTyped,
  WaterQualityCustomizedResultAreaToJSON,
  WaterQualityCustomizedResultAreaToJSONTyped,
} from "./WaterQualityCustomizedResultArea";
import type { PhysicalSettings } from "./PhysicalSettings";
import {
  PhysicalSettingsFromJSON,
  PhysicalSettingsFromJSONTyped,
  PhysicalSettingsToJSON,
  PhysicalSettingsToJSONTyped,
} from "./PhysicalSettings";

/**
 *
 * @export
 * @interface SimulationSettingsOverview
 */
export interface SimulationSettingsOverview {
  /**
   *
   */
  readonly physicalSettings?: PhysicalSettings;
  /**
   *
   */
  readonly numericalSettings?: NumericalSettings;
  /**
   *
   */
  readonly timeStepSettings?: TimeStepSettings;
  /**
   *
   */
  readonly aggregationSettings?: Array<AggregationSettings>;
  /**
   *
   */
  readonly outputSettings?: OutputSettings;
  /**
   *
   */
  readonly customizedResultAreas?: Array<CustomizedResultArea>;
  /**
   *
   */
  readonly waterQualitySettings?: WaterQualitySettings;
  /**
   *
   */
  readonly waterQualityOutputSettings?: WaterQualityOutputSettings;
  /**
   *
   */
  readonly waterQualityCustomizedResultAreas?: Array<WaterQualityCustomizedResultArea>;
}

/**
 * Check if a given object implements the SimulationSettingsOverview interface.
 */
export function instanceOfSimulationSettingsOverview(
  value: object
): value is SimulationSettingsOverview {
  return true;
}

export function SimulationSettingsOverviewFromJSON(json: any): SimulationSettingsOverview {
  return SimulationSettingsOverviewFromJSONTyped(json, false);
}

export function SimulationSettingsOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationSettingsOverview {
  if (json == null) {
    return json;
  }
  return {
    physicalSettings:
      json["physical_settings"] == null
        ? undefined
        : PhysicalSettingsFromJSON(json["physical_settings"]),
    numericalSettings:
      json["numerical_settings"] == null
        ? undefined
        : NumericalSettingsFromJSON(json["numerical_settings"]),
    timeStepSettings:
      json["time_step_settings"] == null
        ? undefined
        : TimeStepSettingsFromJSON(json["time_step_settings"]),
    aggregationSettings:
      json["aggregation_settings"] == null
        ? undefined
        : (json["aggregation_settings"] as Array<any>).map(AggregationSettingsFromJSON),
    outputSettings:
      json["output_settings"] == null ? undefined : OutputSettingsFromJSON(json["output_settings"]),
    customizedResultAreas:
      json["customized_result_areas"] == null
        ? undefined
        : (json["customized_result_areas"] as Array<any>).map(CustomizedResultAreaFromJSON),
    waterQualitySettings:
      json["water_quality_settings"] == null
        ? undefined
        : WaterQualitySettingsFromJSON(json["water_quality_settings"]),
    waterQualityOutputSettings:
      json["water_quality_output_settings"] == null
        ? undefined
        : WaterQualityOutputSettingsFromJSON(json["water_quality_output_settings"]),
    waterQualityCustomizedResultAreas:
      json["water_quality_customized_result_areas"] == null
        ? undefined
        : (json["water_quality_customized_result_areas"] as Array<any>).map(
            WaterQualityCustomizedResultAreaFromJSON
          ),
  };
}

export function SimulationSettingsOverviewToJSON(json: any): SimulationSettingsOverview {
  return SimulationSettingsOverviewToJSONTyped(json, false);
}

export function SimulationSettingsOverviewToJSONTyped(
  value?: Omit<
    SimulationSettingsOverview,
    | "physicalSettings"
    | "numericalSettings"
    | "timeStepSettings"
    | "aggregationSettings"
    | "outputSettings"
    | "customizedResultAreas"
    | "waterQualitySettings"
    | "waterQualityOutputSettings"
    | "waterQualityCustomizedResultAreas"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
